import React, {PropTypes} from 'react';

function ResetIcon(props) {
  const {
    className,
    ...otherProps
  } = props;

  return (
    <svg width='21' height='21' viewBox='0 0 21 21' xmlns='http://www.w3.org/2000/svg' className={`reset-icon ${className}`} {...otherProps}>
      <g strokeWidth='.8' stroke='#4A4A4A' fill='#4A4A4A' fillRule='nonzero'>
        <path d='M19.182 7.531h-5.455a.6.6 0 0 1-.606-.593.6.6 0 0 1 .606-.594h5.455a.6.6 0 0 1 .606.593.6.6 0 0 1-.606.594z'/>
        <path d='M19.606 7.531A.6.6 0 0 1 19 6.938V1.593A.6.6 0 0 1 19.606 1a.6.6 0 0 1 .606.594v5.343a.6.6 0 0 1-.606.594z'/>
        <path d='M10.782 20C5.388 20 1 15.738 1 10.5S5.388 1 10.782 1c3.793 0 7.277 2.16 8.876 5.502a.589.589 0 0 1-.291.79.612.612 0 0 1-.806-.286c-1.401-2.927-4.454-4.819-7.78-4.819-4.725 0-8.569 3.73-8.569 8.313 0 4.584 3.844 8.313 8.57 8.313 4.093 0 7.63-2.824 8.411-6.715a.606.606 0 0 1 .712-.469.595.595 0 0 1 .478.697C19.49 16.773 15.453 20 10.782 20z'/>
      </g>
    </svg>
  );
}


ResetIcon.propTypes = {
  className: PropTypes.string
};

export default ResetIcon;



// WEBPACK FOOTER //
// ./shared/common/svgs/ResetIcon/index.js